import { Typography } from "@material-tailwind/react";
import { useSelector } from "app/hooks";
import { Hero, HeroTitle } from "common/components/Hero";
import { DateTimeLocalize } from "features/users/authenticate/components/DateTimeLocalize";
import { SettingsForm } from "features/users/authenticate/components/SettingsForm";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import { CheckIcon} from "@heroicons/react/24/outline";

export const SettingsScreen = () => {

    const { t } = useTranslation();

    const user = useSelector(state => state.authenticate);

    return (
        <Hero>
            <HeroTitle>{t("Settings")}</HeroTitle>

            <div className="flex flex-row grow justify-start mt-4 space-x-1 px-2 py-1 items-center">
                <Typography className="flex flex-col items-start min-w-28" color="blue-gray" variant="h6" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    {t("Id")}:
                </Typography>
                <Typography className="flex flex-col items-start" variant="small" color="gray" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    {user.userId}
                </Typography>
            </div>
            <div className="flex flex-row grow justify-start space-x-1 px-2 py-1 items-center">
                <Typography className="flex flex-col items-start min-w-28" color="blue-gray" variant="h6" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    {t("Name")}:
                </Typography>
                <Typography className="flex flex-col items-start" variant="small" color="gray" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    {user.name}
                </Typography>
            </div>
            <div className="flex flex-row grow justify-start space-x-1 px-2 py-1 items-center">
                <Typography className="flex flex-col items-start min-w-28" color="blue-gray" variant="h6" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    {t("E-mail")}:
                </Typography>
                <Typography className="flex flex-col items-start" variant="small" color="gray" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    {user.email}
                </Typography>
            </div>
            <div className="flex flex-row grow justify-start space-x-1 px-2 py-1 items-center">
                <div className="flex flex-col justify-start space-x-1 items-center min-w-full">
                    <Typography className="flex flex-col items-start min-w-full" color="blue-gray" variant="h6" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        {t("Priveledges")}:
                    </Typography>
                    <Typography className="flex flex-col items-start min-w-full pl-2" variant="small" color="gray" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        {user.roles?.includes(import.meta.env.VITE_DEMO_ROLE) ? (
                            <div className="flex flex-row">
                                <CheckIcon className="inline-block h-[24px] w-[24px] pr-2" />
                                {t("Demo Priviledge")}
                            </div>
                        ) : (
                            <div className="flex flex-row">
                                <CheckIcon className="inline-block h-[24px] w-[24px] pr-2" />
                                {t("User Priviledge")}
                            </div>
                        )}
                        {user.roles?.includes(import.meta.env.VITE_ADMIN_ROLE) && (
                            <div className="flex flex-row">
                                <CheckIcon className="inline-block h-[24px] w-[24px] pr-2" />
                                {t("Admin Priviledge")}
                            </div>
                        )}
                    </Typography>
                </div>
            </div>
            <div className="flex flex-row grow justify-start space-x-1 px-2 py-1 items-center">
                <Typography className="flex flex-col items-start min-w-28" color="blue-gray" variant="h6" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    {t("Created")}:
                </Typography>
                <Typography className="flex flex-col items-start" variant="small" color="gray" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <DateTimeLocalize 
                        dateTime={DateTime.fromISO(user.createdDate)} 
                        format={"dd-MM-yyyy HH:mm:ss"}
                    />
                </Typography>
            </div>        
            <div className="flex flex-col p-2">
                <SettingsForm />
            </div>
        </Hero>
    );
};

export default SettingsScreen;
